export default "__VITE_ASSET__D1Hn00Mu__"